import React from 'react';
import { ForgeTaskType } from '../../types';
import { FDClassificationUI } from './FDClassificationUI';
import { UncertainClassificationUI } from './UncertainClassificationUI';
import { DesignCuratorUI } from './DesignCuratorUI';
import { DesignReviewUI } from './DesignReviewUI';

interface TaskTypeEntry {
  component: React.FC<{ payload: any; onSelect: (data: any) => void }>;
  label: string;
  shortLabel: string;
}

export const TASK_TYPE_REGISTRY: Record<ForgeTaskType, TaskTypeEntry> = {
  DESIGN_REVIEW: {
    component: DesignReviewUI,
    label: 'Design Review',
    shortLabel: 'Review',
  },
  DESIGN_CURATOR: {
    component: DesignCuratorUI,
    label: 'Design Curator',
    shortLabel: 'Curator',
  },
  UNCERTAIN_CLASSIFICATION: {
    component: UncertainClassificationUI,
    label: 'Uncertain Classification',
    shortLabel: 'Uncertain',
  },
  FD_CLASSIFICATION: {
    component: FDClassificationUI,
    label: 'FD Classification',
    shortLabel: 'FD Review',
  },
};
